import React, { useState } from "react";
import moment from "moment-timezone";
import SendCode from "./SendCode";
import ConfirmOTP from "./ConfirmOTP";
import RetypePassword from "./RetypePassword";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE, OTP_TIMEOUT } from "@/config/constants";

const ResetPassword = ({ changeRoute }) => {
	const [step, setStep] = useState("SEND_CODE"); // SEND_CODE / OTP / RETYPE_PASSWORD
	const [payload, setPayload] = useState({});
	const [expiredDate, setExpiredDate] = useState("");

	const nextStep = (route) => {
		setStep(route);
	};

	const onSendCodeSuccess = (payload) => {
		setPayload(payload);
		nextStep("OTP");
		setExpiredDate(moment().add(OTP_TIMEOUT, "minutes").toString());
	};

	const onSendOTPAgainSuccess = () => {
		setExpiredDate(moment().add(OTP_TIMEOUT, "minutes").toString());
	};

	const onConfirmOTPSuccess = (data) => {
		setPayload({ ...data });
		setStep("RETYPE_PASSWORD");
	};

	const onRetypePasswordSuccess = () => {
		toast({
			type: NOTIFICATION_TYPE.SUCCESS,
			description: "Password Reset Successfully.",
		});

		setStep("SEND_CODE");
		changeRoute && changeRoute("LOGIN");
	};

	const _renderResetPasswordWithProcess = () => {
		switch (step) {
			case "SEND_CODE":
				return <SendCode nextStep={nextStep} onSendCodeSuccess={onSendCodeSuccess} />;
			case "OTP":
				return (
					<ConfirmOTP
						nextStep={nextStep}
						expiredDate={expiredDate}
						payload={payload}
						onBack={() => setStep("SEND_CODE")}
						onConfirmOTPSuccess={onConfirmOTPSuccess}
						onSendOTPAgainSuccess={onSendOTPAgainSuccess}
					/>
				);
			case "RETYPE_PASSWORD":
				return (
					<RetypePassword
						nextStep={nextStep}
						payload={payload}
						onRetypePasswordSuccess={onRetypePasswordSuccess}
					/>
				);
			default:
				return null;
		}
	};

	return _renderResetPasswordWithProcess();
};

export default ResetPassword;
